import React, { useCallback, useEffect, useState,  } from "react";
import { QueryClient, useMutation } from "react-query";
import { Feature } from 'models/api';
import { useAlert } from 'contexts/alertContext';
import { handleError } from 'helpers/utils';
// import { getWorkshopEvaluations } from 'framework/workshopEvaluation';
import {
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Container,
  CircularProgress,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
  Select,
  MenuItem,
} from '@mui/material';
// import { IWorkshopEvaluation } from 'models/EmployeeWorkshopEvaluation';
import { ICompanyCompetency } from 'models/companyCompetencies';
import { ICompetency, ICompetencyMapping } from 'models/competencyMapping';
import { getCompetencyMapping, saveCompetencyMapping } from 'framework/competencyMapping';
import { getCompanyCompetencies } from 'framework/companyCompetencies';
import { Link, useParams } from "react-router-dom";

interface Props {
  feature: Feature;
}

const CompetencyMapping: React.FC<Props> = ({ feature }) => {
  const [competencyMapping, setCompetencyMapping] = useState<ICompetencyMapping[]>([]);
  const [companyCompetencies, setCompanyCompetencies] = useState<ICompetency[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const queryClient = new QueryClient();
  const urlParams = useParams();
  const { setAlert } = useAlert();
  let id: string = urlParams[`${feature.singleName}Id`] as string;

  const submitMappingMutation = useMutation({
    mutationFn: (mapping: ICompetencyMapping[]) => {
      return saveCompetencyMapping(mapping);
    },
  });

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      let response: any = await queryClient.fetchQuery(
        "get workshop evaluation questions",
        () =>
          getCompetencyMapping(
            `/${id}`
          )
      );
      response =
        response && response.length > 0
          ? response.map((item: ICompetencyMapping) => ({
            ...item,
          }))
          : [];
      setCompetencyMapping(response);
      setLoading(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading(false);
    }

    // eslint-disable-next-line
  }, [queryClient, setAlert]);

  const fetchCompanyCompetencies = useCallback(async () => {
    setLoading(true);
    try {
      let response: any = await queryClient.fetchQuery("get dimensions", () =>
        getCompanyCompetencies()
      );
      response =
        response && response.length > 0
          ? response.map((item: ICompanyCompetency) => ({
            ...item,
          }))
          : [];
      setCompanyCompetencies(response);
      setLoading(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading(false);
    }

    // eslint-disable-next-line
  }, [queryClient, setAlert]);

  useEffect(() => {
    fetchData();
    fetchCompanyCompetencies();
    // eslint-disable-next-line
  }, []);


  const handleDropdownChange = (corporateCompetencyId: string, selectedCompetencyId: string) => {
    setCompetencyMapping(prev =>
      prev.map(mapping =>
        mapping.corporateCompetency.id === corporateCompetencyId
          ? {
            ...mapping,
            mappedCompetencies: companyCompetencies.find(c => c.id === selectedCompetencyId) || null,
          }
          : mapping
      )
    );
    
  };

  const handleSubmit = () => {
    submitMappingMutation.mutate(competencyMapping);
  };

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><Typography>Corporate Competency</Typography></TableCell>
              <TableCell><Typography>Mapped Competency</Typography></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {competencyMapping.map(mapping => (
              <TableRow key={mapping.corporateCompetency.id}>
                <TableCell>
                  {mapping.corporateCompetency.name}
                </TableCell>
                <TableCell>
                  <Select
                    value={mapping.mappedCompetencies?.id || ""}
                    onChange={(event) =>
                      handleDropdownChange(mapping.corporateCompetency.id, event.target.value)
                    }
                    displayEmpty
                    fullWidth
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {companyCompetencies.map(competency => (
                      <MenuItem key={competency.id} value={competency.id}>
                        {competency.name}
                      </MenuItem>
                    ))}
                  </Select>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        // disabled={mutation.isLoading}
      >
        Submit
      </Button>
    </>
  );
};

export default CompetencyMapping;
